var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlayIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "playButtonTippy",
    role: "img",
    "aria-labelledby": titleId,
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.43 48.31",
    width: 15,
    ref: ref
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "playButton"
  }, "play promo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "playButton"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.63.46,42,23.06a1.54,1.54,0,0,1,0,2.19L2.63,47.86A1.54,1.54,0,0,1,0,46.76V1.55A1.54,1.54,0,0,1,2.63.46Z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlayIcon);
export default ForwardRef;